module.exports = __webpack_public_path__ + "img/messenger-logo.7bcd4934.png";